import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,CloseOutlined,FileImageOutlined,VideoCameraOutlined } from '@ant-design/icons';
import ModalImage from "react-modal-image";
import axios from 'axios';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import camera from '../../assets/images/icon/camera.png';
import plus from '../../assets/images/icon/plus.png';
import pen from '../../assets/images/icon/pen.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const storedFiles=[];

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			previewVisible: false,
			previewImage: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			category_list: [],
			payee_list: [],
			category_details: [],
			loading: false,
			value: '',
			visible: '',
			visible_category: '',
			payee: '',
			visible1: '',
			visible2: '',
			visible3: '',
			payee_: '',
			popup_title: '',
			payee_value: '',
			category_value: '',
			header: '',
			amount: '',
			category: '',
			payee: '',
			payment_date: '',
			payment_status: '',
			reference_number: '',
			comment: '',
			description: '',
			split_amount: '',
			tax: '',
			total: '',
			conf_password: '',
			password: '',
			values: [2],
			selectedFiles:null,
			file_list: [],
		}
		this.change_payment = this.change_payment.bind(this);
		this.onChange_ = this.onChange_.bind(this);
		this.goBack = this.goBack.bind(this);
	}
	
	handleFileSelect= (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFiles.length > 10) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 40000001) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 30MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'image',
							selectedFiles: f
						}
						storedFiles.push(app);
						people.push(f);
					}				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list:storedFiles});
		}, 500);
	} 

	removeFile= (file,e) =>{
		for (var i = 0; i < storedFiles.length; i++) {
			if (storedFiles[i].file_name === file) {
				storedFiles.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFiles.length=='0') {
				const file = document.querySelector('.file');
				file.value = '';
			}			
			this.setState({file_list:storedFiles});
			//console.log(storedFiles);
		}, 500);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getData('erp/expenses_category_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							category_list: result['data'],
						});
					}else{
						this.setState({
							category_list: [],
							
						});
					}
				}
			});
			
			getData('erp/expenses_payee_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							payee_list: result['data'],
						});
					}else{
						this.setState({
							payee_list: [],
							
						});
					}
				}
			});
	}
  }
  
  
  
  onChange_(date, dateString) {
	  this.setState({ payment_date: dateString });
	}
	
	change_payment(event){
         this.setState({payment_status: event});
     }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

		this.setState({
		  previewImage: file.url || file.preview,
		  previewVisible: true,
		  previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
		});
	};
	
	handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        }),
      );
    }
  };
  
  showModal = () => {
		this.setState({
		  visible: true,
		});
	  };

	  handleOk = () => {
		this.setState({ loading: true });
		setTimeout(() => {
		  this.setState({ loading: false, visible: false });
		}, 3000);
	  };

	  handleCancel = () => {
		this.setState({ visible: false });
	  };
	  
	 showModal1 = (name) => {
		this.setState({
		  visible1: true,
		  popup_title: name,
		});
		
	  };

	  handleOk1 = e => {
		console.log(e);
		this.setState({
		  visible1: false,
		});
		
		var user_id = this.state.user_id;
		var school_id = this.state.school_id;
		var popup_title = this.state.popup_title;
		var popup_name = this.state.popup_name;
		var popup_description = this.state.popup_description;
		if(localStorage.getItem('schoolData')){
		var app = { user_id:user_id,popup_title : popup_title , name : popup_name,description : popup_description,school_id:school_id }
		  getData('erp/expenses_category_add',app).then((result) => {
		  if(result.status==400){
				 message.config({ top: 150});
				message.error('Please Insert All Field',2);
				this.setState({ loading: false });
			  }
			  if(result.status==200){
				message.config({ top: 150});
				message.success('Added',2);
				this.checkData();
				document.getElementById("popup_name").value = '';
				document.getElementById("popup_description").value = '';
				this.setState({
				  popup_title: '',
				  popup_name: '',
				  popup_description: '',
				});
			  }
		  });
		  }else{
			message.error('Please Login',2);	
		  }
		
		
	  };

	  handleCancel1 = e => {
		console.log(e);
		this.setState({
		  visible1: false,
		});
	  };
	  
	  showModal2 = (id) => {
		this.setState({
		  visible2: true,
		  
		});
		if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			
			var app = {user_id : user_id,id:id}
			getData('erp/expenses_category_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							category_details: result['data'],
						});
						document.getElementById("category_name").value = result['data'][0]['name'];
						document.getElementById("category_description").value = result['data'][0]['description'];
						document.getElementById("category_id").value = result['data'][0]['id'];
						
					}else{
						this.setState({
							category_details: [],
							
						});
					}
				}
			});
			}
		};

	  handleOk2 = e => {
		console.log(e);
		this.setState({
		  visible2: false,
		});
		var user_id = this.state.user_id;
		var category_id = document.getElementById('category_id').value; 
		var category_name = this.state.category_name;
		var category_description = this.state.category_description;
		if(localStorage.getItem('schoolData')){
		var app = { user_id:user_id,category_id : category_id , name : category_name,description : category_description }
		  getData('erp/expenses_category_edit',app).then((result) => {
		  if(result.status==400){
				 message.config({ top: 150});
				message.error('Please Insert All Field',2);
				this.setState({ loading: false });
			  }
			  if(result.status==200){
				message.config({ top: 150});
				message.success('Updated',2);
				this.checkData();
			  }
		  });
		  }else{
			message.error('Please Login',2);	
		  }
		
	  };

	  handleCancel2 = e => {
		console.log(e);
		this.setState({
		  visible2: false,
		});
	  };
	  
	  
	  showModal3 = (id) => {
		this.setState({
		  visible3: true,
		  
		});
		if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			
			var app = {user_id : user_id,id:id}
			getData('erp/expenses_payee_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							category_details: result['data'],
						});
						document.getElementById("payee_name").value = result['data'][0]['name'];
						document.getElementById("payee_description").value = result['data'][0]['description'];
						document.getElementById("payee_id").value = result['data'][0]['id'];
						
					}else{
						this.setState({
							category_details: [],
							
						});
					}
				}
			});
			}
		};

	  handleOk3 = e => {
		console.log(e);
		this.setState({
		  visible3: false,
		});
		var user_id = this.state.user_id;
		var category_id = document.getElementById('payee_id').value; 
		var category_name = this.state.payee_name;
		var category_description = this.state.payee_description;
		if(localStorage.getItem('schoolData')){
		var app = { user_id:user_id,category_id : category_id , name : category_name,description : category_description }
		  getData('erp/expenses_payee_edit',app).then((result) => {
		  if(result.status==400){
				 message.config({ top: 150});
				message.error('Please Insert All Field',2);
				this.setState({ loading: false });
			  }
			  if(result.status==200){
				message.config({ top: 150});
				message.success('Updated',2);
				this.checkData();
			  }
		  });
		  }else{
			message.error('Please Login',2);	
		  }
		
	  };

	  handleCancel3 = e => {
		console.log(e);
		this.setState({
		  visible3: false,
		});
	  };
	
	 showModalpayee = () => {
		this.setState({
		  payee: true,
		});
	  };

	  handleOkpayee = () => {
		this.setState({ loading: true });
		setTimeout(() => {
		  this.setState({ loading: false, payee: false });
		}, 3000);
	  };

	  handleCancelpayee = () => {
		this.setState({ payee: false });
	  };

	 showModalpayee_ = () => {
		this.setState({
		  payee_: true,
		});
	  };

	  handleOkpayee_ = e => {
		console.log(e);
		this.setState({
		  payee_: false,
		});
	  };

	  handleCancelpayee_ = e => {
		console.log(e);
		this.setState({
		  payee_: false,
		});
	  };

	setpayee = (name) => {
		this.setState({
		  payee_value : name,
		   payee: false,
		});
	};	
	
	setcategory = (name) => {
		this.setState({
		  category_value : name,
		   visible: false,
		});
	};	
	
  handleChange = ({ fileList }) => this.setState({ fileList });
	
  
   
  
  
  handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		if(this.state.conf_password != '' && this.state.password != '')
		{
		
		if(this.state.conf_password == this.state.password )
		{
		var app = {
			user_id: this.state.user_id ,
			school_id: this.state.school_id ,
			password: this.state.password ,
		}
      getData('erp/change_password',app).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
								message.config({ top: 150});
								message.success('Password Change Successfull !!',2);
								this.setState({ loading: false });
								this.setState({comment_text:''});
								window.location.href = '/';

          }
      });
	  }else{
			message.config({ top: 150});
			message.error('Password Dosnt Match !!',2);
			this.setState({ loading: false });
	  }
	  
	  }else{
			message.config({ top: 150});
			message.error('PLease Insert All Field !!',2);
			this.setState({ loading: false });
	  }
	  }
	  else{
		message.error('Please Login',2);	
		this.setState({ loading: false });
	  }

  }
	
	goBack(){
		window.location.href = '/expenses/index';
	}
	
	render()

	{
	const { payee_,visible1,visible2, visible3, visible,payee, loading } = this.state;	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <div className="ant-upload-text snd-btn new">Add Files</div>
      </div>
    );	
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		  <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Change Password</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Change Password
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
			 <div class="col s12 m12 ex-padd">
            <div class="container view-Profile child-profile">
			   <div class="col s12 m12 mb-20 iq-card card card-content iq-card">
                  <section class="invoice-list-wrapper section food mh-500">
					<div class="children mb-20 iq-card2 flow-root">
                    
						<div class="bb d-flex">
						  
						  <div class="col m12 no-padd">
								<div class="col m6 s12 mb-10 mt-10">
									<label>New Password</label>
									<input type="password" name="password" id="header" onChange={this.handleSizeChange}   />
								</div>	
								<div class="col m6 s12 mt-10 mb-10">
									<label>Confirm Password</label>
									<input type="password" name="conf_password" id="amount" onChange={this.handleSizeChange}  />
								</div>	
									
								
								
								
						  </div>
						</div>
							
					</div> 
					
									
								

					
					
					
					<div class="col m12 s12 meal mb-20 center">
														 <Button className="cancel-btn large-btn" onClick={this.context.router.history.goBack}>Back</Button>
														 <Button className="snd-btn large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Change</Button>
													</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
